import React from 'react';
import Edge from './Edge.js';
import {OSCILLATOR} from 'constants/effect-types.js';

export default function ModulatorEdges({lfoEdges, envelopeEdges, rack, setSelectedEdge, selectedEdge, width}) {
    let list = [];
    for (let i in rack.modulators) {
        let modulator = rack.modulators[i];
        let modEdges = modulator.getType() === 'LFO' ?
            lfoEdges[modulator.number] :
            envelopeEdges[modulator.number];
        if (modEdges === undefined) {
            continue;
        }
        let _modEdges = {};
        modEdges.forEach(x => _modEdges[x.id] = x);
        list = [... list,
                ... Object.keys(_modEdges).map(
                    id =>
                        <Edge
                          key={modulator.getType() + "-" + modulator.number+ "-"+ "edge-" + id}
                          modulator={modulator}
                          edge={_modEdges[id]}
                          setSelectedEdge={setSelectedEdge}
                          width={width}
                          rack={rack}
                          selected={
                              selectedEdge ?
                                  selectedEdge.modulator === modulator &&
                                  selectedEdge.edge === _modEdges[id] :
                                  false}/>
                )];
    }

    return (
        <g>
          {list}
        </g>
    );
}
